export default {
  enums: {
    config: {
      permissions: {
        permissions: {
          see_content: 'inhoud bekijken',
          manage_content: 'inhoud wijzigen',
          delete_content: 'inhoud verwijderen',
          see_work: 'dossiers bekijken',
          manage_work: 'dossiers wijzigen',
          delete_work: 'dossiers verwijderen',
          see_invoicing: 'facturatie bekijken',
          manage_invoicing: 'facturatie wijzigen',
          delete_invoicing: 'in de facturatie verwijderen',
          see_tasks: 'taken bekijken',
          manage_tasks: 'taken wijzigen',
          see_settings: 'instellingen bekijken',
          manage_settings: 'instellingen wijzigen',
          see_planning: 'planning bekijken',
          manage_planning: 'planning wijzigen',
          delete_planning: 'in de planning verwijderen'
        },
        permissions_group: {
          content: 'inhoud',
          work: 'dossier',
          invoicing: 'facturatie',
          planning: 'planning',
          tasks: 'taken',
          settings: 'instellingen'
        },
        roles: {
          'super-admin': 'superbeheerder',
          'crema-user': 'gebruiker van het crematorium',
          'customer-user': 'klantgebruiker'
        }
      }
    },
    mode: {
      BAN: 'Bankoverschrijving',
      CAR: 'bankpas',
      CAS: 'contante betaling',
      CHE: 'cheque',
      CRN: 'credit nota',
      ELE: 'elektronische betaling',
      INS: 'zekerheid'
    },
    invoice_status: {
      CAN: 'geannuleerd',
      DRA: 'ongeorganiseerd',
      EST: 'vastgesteld',
      FRM: 'eerste herinnering',
      LAW: 'advocaat',
      PAI: 'betaald',
      PBI: 'betaling in termijnen',
      PP: 'gedeeltelijk betaald',
      SRM: 'tweede herinnering'
    },
    asset_type: {
      ROM: 'salle',
      OVE: 'four',
      LAW: 'pelouse',
      GRA: 'inhumation',
      OTH: 'autre'
    },
    yes_no: {
      true: 'ja',
      false: 'nee',
      0: 'nee',
      1: 'ja'
    },
    event_type: {
      REC: 'réception',
      CER: 'cérémonie',
      ASR: 'reprise des cendres',
      DIS: 'dispersion',
      CRE: 'crémation',
      INH: 'inhumation',
      OTH: 'autre'
    }
  }
}
